import API_BASE from "../config/api";


export const fetchVehicleDetails = async (invoiceId, detailId) => {

  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Vehicle/Detail?invoice_id=${invoiceId}&detail_id=${detailId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token
      }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch vehicle details");
  }

  return await response.json();
};